@if ((selectedMontage$ |async)) {
  <icc-select-box [title]="'MOSQUITO|Rodzaj mocowania' | translate"
    [description]="(selectedMontage$ | async)?.name"
    [imageUrl]="'/files/mosquitomontage/' + ((selectedMontage$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeMontage()"
  ></icc-select-box>
}

@if (showProfilePositionSelection$ | async) {
  <div class="box-form mat-elevation-z3">
    <h4>{{ 'MOSQUITO|Wybierz z której strony ma się znajdować profil dodatkowy:' | translate }}</h4>
    <form [formGroup]="profilePositionForm">
      <mat-checkbox name="profile-position-up" formControlName="up">{{ 'INTERFACE|Góra'| translate }}</mat-checkbox>
      <mat-checkbox name="profile-position-down" formControlName="down">{{ 'INTERFACE|Dół'| translate }}</mat-checkbox>
      <mat-checkbox name="profile-position-left" formControlName="left">{{ 'INTERFACE|Lewa'| translate }}</mat-checkbox>
      <mat-checkbox name="profile-position-right" formControlName="right">{{ 'INTERFACE|Prawa'| translate }}</mat-checkbox>
    </form>
  </div>
}

@if (showMuntinPositionSelection$ | async) {
  <div class="box-form mat-elevation-z3">
    <h4>{{ 'MOSQUITO|Wysokość szprosu' | translate }}</h4>
    <form [formGroup]="muntinPositionForm">
      <mat-radio-group formControlName="muntinType">
        <mat-radio-button value="standard">{{ 'MOSQUITO|Standardowa'| translate }}</mat-radio-button>
        <mat-radio-button value="custom">{{ 'MOSQUITO|Inna wysokość (mm):'| translate }}</mat-radio-button>
      </mat-radio-group>
      @if (muntinPositionForm.get('muntinType')?.value === 'custom') {
        <mat-form-field>
          <input matInput iccDimensionInput type="number" formControlName="position"/>
        </mat-form-field>
      }
    </form>
  </div>
}

@if (windowLines.length > 0) {
  <div class="box-form mat-elevation-z3">
    <h4>{{ 'MOSQUITO|Wybierz rozmiar uchwytów'| translate }}</h4>
    <form [formGroup]="holdersForm">
      <mat-radio-group formControlName="line">
        @for (line of windowLines; track line) {
          <mat-radio-button [value]="line.id">{{line.content}}</mat-radio-button>
        }
        <mat-radio-button [value]="null">{{ 'MOSQUITO|Inny rozmiar'| translate }}</mat-radio-button>
      </mat-radio-group>
      @if (!holdersForm.get('line')?.value) {
        <mat-form-field>
          <input matInput iccDimensionInput type="number" formControlName="width">
        </mat-form-field>
      }
    </form>
  </div>
}

@if (showThickSealSelection$ | async) {
  <div class="box-form mat-elevation-z3">
    <form [formGroup]="thickSealForm">
      <mat-slide-toggle formControlName="hasThickSeal">{{ 'MOSQUITO|Słupek niezlicowany'| translate }}</mat-slide-toggle>
      @if (thickSealForm.get('hasThickSeal')?.value) {
        <label>{{ 'MOSQUITO|Grubość uszczelki'| translate }}</label>
      }
      @if (thickSealForm.get('hasThickSeal')?.value) {
        <mat-radio-group formControlName="sealThickness" >
          <mat-radio-button [value]="10">10 {{dimensionUnit.unitSymbol}}</mat-radio-button>
          <mat-radio-button [value]="15">15 {{dimensionUnit.unitSymbol}}</mat-radio-button>
        </mat-radio-group>
      }
    </form>
  </div>
}